import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CertificadosEditor from './CertificadosEditor/CertificadosEditor';
import './CertificateBuilderPage.css';

function CertificateBuilderPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const xsdId = searchParams.get('xsdId');
  const xsdName = searchParams.get('xsdName') || '';
  const xsdVersion = searchParams.get('xsdVersion');
  const returnTo = location.state?.returnTo || '/certificate-configuration';
  const returnState = location.state?.returnTab
    ? {
      activeTab: location.state.returnTab,
      builderXsdId: location.state.returnBuilderXsdId || '',
      builderXsdVersion: location.state.returnBuilderXsdVersion || '',
    }
    : undefined;
  const editor = (
    <CertificadosEditor
      key={xsdId ? `${xsdId}:${xsdVersion || 'missing-version'}` : 'unscoped'}
      xsdId={xsdId}
      xsdName={xsdName}
      xsdVersion={xsdVersion}
      onBack={() => navigate(returnTo, { state: returnState })}
    />
  );

  return <div className="certificate-builder-fullscreen" data-testid="certificate-builder-fullscreen">{editor}</div>;
}

export default CertificateBuilderPage;